import * as React from "react";
import type { SVGProps } from "react";
const SvgTrendUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.37 6.3H17.7m0 0v10.183m0-10.183L6.3 17.7"
    />
  </svg>
);
export default SvgTrendUp02;
